import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import {useTranslation} from 'react-i18next';
import NewEmployeeFormComponent from '../NewEmployeeFormComponent';
import {isFormValid} from '../../../hooks/useEmployeeHandlers';
import type {NewEmployee} from '../../../types/employee';

interface EditEmployeeDialogProps {
    open: boolean;
    employee: NewEmployee;
    onClose: () => void;
    onSubmit: () => void;
    handleFormChange: (field: keyof NewEmployee) => (event: any) => void;
    handleCheckboxChange: (field: keyof NewEmployee) => (event: any) => void;
    backendError?: { message: string; violations: string[] } | null;
}

const EditEmployeeDialog: React.FC<EditEmployeeDialogProps> = ({
                                                                   open,
                                                                   employee,
                                                                   onClose,
                                                                   onSubmit,
                                                                   handleFormChange,
                                                                   handleCheckboxChange,
                                                                   backendError,
                                                               }) => {
    const {t} = useTranslation();
    const [showAllErrors, setShowAllErrors] = React.useState(false);

    const handleSave = () => {
        if (!isFormValid(employee)) {
            setShowAllErrors(true);
            return;
        }
        setShowAllErrors(false);
        onSubmit();
    };

    const handleClose = () => {
        setShowAllErrors(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={() => {
        }} disableEscapeKeyDown maxWidth="sm" fullWidth>
            <DialogTitle>{t('employee.dialog.editTitle')}</DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, mt: 2}}>
                    <NewEmployeeFormComponent
                        newEmployee={employee}
                        handleFormChange={handleFormChange}
                        handleCheckboxChange={handleCheckboxChange}
                        showAllErrors={showAllErrors}
                        showBranch={false}
                        backendError={backendError}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    {t('common.actions.cancel')}
                </Button>
                <Button onClick={handleSave} variant="contained" color="primary" startIcon={<SaveIcon/>}>
                    {t('employee.dialog.updateButton')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditEmployeeDialog;
